import { render, staticRenderFns } from "./StreakNoUser.vue?vue&type=template&id=0bb236c8&scoped=true&"
import script from "./StreakNoUser.vue?vue&type=script&lang=ts&"
export * from "./StreakNoUser.vue?vue&type=script&lang=ts&"
import style0 from "./StreakNoUser.vue?vue&type=style&index=0&id=0bb236c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb236c8",
  null
  
)

export default component.exports